import { gql } from '../../../artifacts/gql';

export const verifyPhone = gql(`
  mutation collectVerifyPhone($code: String!) {
    collectVerifyPhone(code: $code) {
      successful
      messages {
        message
        code
        field
      }
    }
  }
`);
